import EnCours from '@/views/consultations/en-cours'
import kineApi from '@/api/_kine-clinical'
import { clinicalToken } from '@/utils/kine-reeducation'
import {
    ouvrirComplement, terminerComplement, observerComplement, complementActif, verifierContexteComplement
} from '@/utils/complement-session'
import { fuseauComplement } from '@/utils/complement-date'
const Historique = () => import('@/views/consultations/historique')
const DossierMedical = () => import('@/views/dossierMedical/dossier-medical')
const TraitementEnCours = () => import('@/views/consultations/en-cours/protocole-soins/traitement-en-cours')
const PlanAdministrationInfirmier = () => import('@/views/patientInfo/plan-administration-infirmier.vue')
const SortieHospitalisation = () => import('@/views/patientInfo/sortie-hospitalisation.vue')
// Parcours du patient et transfert entre services (04/10/2026).
const ParcoursBandeau = () => import('@/views/patientInfo/parcours-bandeau.vue')
const SuivisKine = () => import('@/views/patientInfo/suivis-kine')
const Vaccinations = () => import('@/views/patientInfo/vaccinations.vue')

import store_patient from "@/store/mods/patients/patient"
import sage_femme_api from '@/modules/sage-femme/api'
import store_consultation from '@/store/mods/consultations/consultations'
import infirmier_api from '@/api/_infirmier'

// importing patient datas
import PatientProfileBasic from '@/views/patientInfo/patient-profile-basic'
const PatientInfoPerso = () => import('@/views/patientInfo/infos-personnels-tab-content')
import ProfilTabMenu from '@/views/patientInfo/profile-tabs-menu'

const ResultatPatient = () => import('@/views/analyse/registre_analyse/resultat-patient')

// Travailleurs components
const TravailleurVisitePoste = () => import('@/views/mdt/travailleurs/t-visite-poste')
const TravailleurVisiteMedicale = () => import('@/views/mdt/travailleurs/t-visite-medicale')
const TravailleurAttReprise = () => import('@/views/mdt/travailleurs/t-att-reprise')

const PrintComponents = () => import('@/components/print-components')
const AddPatient = () => import('@/views/addPatient')

export default {
    fields: [{ key: 'index', label: 'N°' }, { key: 'champs', label: 'Champs modifiés' }],
    name: 'patient-info',
    components: {
        EnCours, DossierMedical, PatientProfileBasic, ProfilTabMenu,
        PatientInfoPerso, Historique, TravailleurVisitePoste, TravailleurVisiteMedicale,
        TravailleurAttReprise, TraitementEnCours, PlanAdministrationInfirmier, SortieHospitalisation, ParcoursBandeau,
        ResultatPatient, PrintComponents, AddPatient, SuivisKine, Vaccinations
    },
    props: ["consultation"],

    data() {
        return {
            user_role: '',
            patient_id: 0,
            can_see_consultation: false,

            is_loading: true,
            data_is_available: false,
            traitement_view_toggler: 0,
            onglet_patient_actif: '1',
            panneau_actions_disponible: false,
            info_personne_a_prevenir: {
                personne_a_prevenir_nom: '',
                personne_a_prevenir_prenom: '',
                personne_a_prevenir_profession: '',
                personne_a_prevenir_quartier: '',
                personne_a_prevenir_telephone: ''
            },
            pers_a_prevenir_loading: true,
            can_print: false,
            view_result_loading: false,
            results: null,
            user_info: {},
            c_loading: true,
            erreur_tableau_medecin: '',
            erreur_complement: '',
            info_assure_principal: {},
            assurance_loading: true,
            assurance_erreur: false,
            sequence_assurance: 0,
            sequence_patient: 0,
            sequence_contact: 0,
            sequence_consultation: 0,
            profil_modal_ouvert: false,
            kine_sortie_confirmee: false,
            kine_specialites_suivies: [],
        }
    },

    watch: {
        can_see_kine() { this.charger_specialites_kine() },
        consultationEnCours(consultation) {
            verifierContexteComplement(this.$route.params.id, consultation && consultation.id)
        },
        'activeRole.nom'(role) {
            const query = this.$route.query || {}
            const selection = this.selected_consultation_encours || {}
            if (!Object.prototype.hasOwnProperty.call(query, 'sf001') && !selection.source_tableau_sage_femme) return
            this.user_role = role
            this.sequence_consultation++
            this.can_see_consultation = false
            this.c_loading = false
            this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', [])
            this.erreur_tableau_medecin = 'Le rôle a changé. Rouvrez la consultation depuis votre tableau de bord.'
        },
        data_is_available(disponible) {
            if (disponible) this.$nextTick(this.observer_entete_patient)
        },
        '$route.params.id'(patient_id, precedent) {
            if (String(patient_id) !== String(precedent)) this.initialiser_dossier()
        },
        '$route'(destination, origine) {
            if (String(destination.params.id) !== String(origine.params.id)) return
            const selection = route => [
                route.params.consultation, route.query.sf001, route.query.inf001, route.query.med004, route.query.tarif, route.query.suivi
            ].map(valeur => String(valeur || '')).join('|')
            if (selection(destination) === selection(origine)) return
            this.onglet_patient_actif = '1'
            this.getConsultationEnCoursByTypeConsultation()
        },
        can_print_result() {
            if (this.can_print_result == true) {
                this.printResultatPatient()
            }
        }
    },

    computed: {
        parcours_dans_actions() {
            return this.can_see_consultation && this.onglet_patient_actif === '3' &&
                this.panneau_actions_disponible && Number(this.consultationEnCours.is_start) === 1
        },
        can_see_kine() { return process.env.VUE_APP_KINE_CLINICAL_ENABLED === 'true' && this.activeRole && this.activeRole.nom === 'ROLE_MEDECIN' },
        consultation_kine() {
            const tarif = this.consultationEnCours.tarif_consultation
            const type = tarif && tarif.type_consultation
            return this.can_see_kine && this.kine_specialites_suivies.includes(Number(type && type.id))
        },
        kine_specialty_id() {
            const tarif = this.consultationEnCours.tarif_consultation
            return tarif && tarif.type_consultation && Number(tarif.type_consultation.id) || null
        },
        /**
         * User Info
         * @returns 
         */
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        /**
         * User Active role
         * @returns 
         */
        activeRole() {
            return this.$store.getters['activeRole'];
        },

        patient() {
            return this.$store.getters['patient'] || {};
        },

        patientHistorique() {
            return this.$store.getters['historiques']
        },

        consultationEnCours() {
            return this.$store.getters['consultationPatientEnCours'] || {}
        },

        liste_access_checker_type_consultation() {
            return this.$store.getters['liste_access_checker_type_consultation'];
        },

        selected_consultation_encours() {
            return this.$store.getters['selected_consultation_encours']
        },

        can_print_result() {
            return this.$store.getters['can_print_result']
        },

        resulat_patient_to_print() {
            return this.$store.getters['resulat_patient_to_print']
        },

        add_result_loader() {
            return this.$store.getters['add_result_loader']
        },
    },

    mounted() {
        this.charger_specialites_kine()
        this._finComplement = observerComplement(message => {
            if (message) {
                this.erreur_complement = message
                if (typeof this.errorToast === 'function') this.errorToast(message)
            }
            if (this.consultationEnCours.complement && !complementActif(this.consultationEnCours.id)) {
                this.can_see_consultation = false
                this.changeTab('4')
            }
        })
        this.user_info = {
            id: this.userCredentials.id,
            user: this.userCredentials.name,
            titre: this.userCredentials.titre
        }
        this.user_role = this.activeRole.nom;
        this.initialiser_dossier()
        this.$store.commit("SET_CAN_PRINT_RESULT", false)
    },

    beforeDestroy() {
        if (this._finComplement) this._finComplement()
        terminerComplement()
        this.arreter_observation_entete()
        this.sequence_patient++
        this.sequence_assurance++
        this.sequence_contact++
        this.sequence_consultation++
    },

    methods: {
        async charger_specialites_kine() {
            this.kine_specialites_suivies = []
            if (!this.can_see_kine) return
            const identity = this.userCredentials.id
            const current = () => !this._isDestroyed && this.can_see_kine && this.userCredentials.id === identity
            try {
                const token = await clinicalToken(current)
                const response = await kineApi.getTableau({ onglet: 'aujourdhui', page: 1, search: '' }, token)
                if (current()) this.kine_specialites_suivies = (response.specialites && response.specialites.suivies || []).map(Number)
            } catch (_) { /* L’éditeur natif affiche l’erreur du suivi ; aucun classement par nom. */ }
        },
        garder_brouillon_kine(event) {
            if (this.kine_sortie_confirmee) { this.kine_sortie_confirmee = false; return }
            const kine = this.$refs.suivisKine, target = event.target && event.target.closest && event.target.closest('a[data-toggle="tab"]')
            if (this.onglet_patient_actif !== '3' || !kine || !target || /-3$/.test(target.id) || (!kine.hasUnsaved && !kine.saving)) return
            event.preventDefault(); event.stopImmediatePropagation()
            kine.requestLeave(() => { this.kine_sortie_confirmee = true; target.click() })
        },
        profil_enregistre() {
            this.profil_modal_ouvert = false
            // Conserver l'onglet et la consultation en cours pendant la mise à jour du bandeau.
            this.rafraichir_mesures_patient()
            this.getPersonneAprevenir()
            this.charger_assurance()
        },
        async rafraichir_mesures_patient() {
            const patient_id = Number(this.$route.params.id)
            try {
                const patient = await store_patient.getPatient(patient_id)
                if (!this._isDestroyed && Number(this.$route.params.id) === patient_id && Number(patient.id) === patient_id) {
                    this.$store.commit('SET_PATIENT', patient)
                }
            } catch (error) {
                // Le dossier reste utilisable ; les dernières mesures réapparaîtront au rechargement.
            }
        },
        arreter_observation_entete() {
            if (this._patientStickyObserver) this._patientStickyObserver.disconnect()
            if (this._patientStickyCleanup) this._patientStickyCleanup()
            this._patientStickyObserver = null
            this._patientStickyCleanup = null
        },
        observer_entete_patient() {
            this.arreter_observation_entete()
            const entete = this.$refs.patientStickyShell
            if (!entete) return
            const scrollport = entete.closest('.content-body')
            const wrapper = entete.closest('.wrapper')
            const navbar = wrapper && wrapper.querySelector('.navbar')
            const ajuster = () => {
                if (this.$el && entete.isConnected) {
                    const rect = entete.getBoundingClientRect()
                    this.$el.style.setProperty('--dossier-sticky-height', `${Math.ceil(rect.height)}px`)
                    let gap = 0
                    if (scrollport && navbar) {
                        const style = window.getComputedStyle(scrollport)
                        const limite = navbar.getBoundingClientRect().bottom
                        const ancrage = scrollport.getBoundingClientRect().top +
                            (parseFloat(style.borderTopWidth) || 0) + (parseFloat(style.paddingTop) || 0)
                        // Cap at the sticky docking gap, so a warning above the card stays visible.
                        gap = Math.max(0, Math.min(rect.top - limite, ancrage - limite))
                    }
                    this.$el.style.setProperty('--dossier-sticky-mask-gap', `${gap}px`)
                }
            }
            let frame = null
            const programmer = () => {
                if (frame !== null) return
                frame = window.requestAnimationFrame(() => { frame = null; ajuster() })
            }
            if (scrollport) scrollport.addEventListener('scroll', programmer, { passive: true })
            window.addEventListener('resize', programmer)
            this._patientStickyCleanup = () => {
                if (scrollport) scrollport.removeEventListener('scroll', programmer)
                window.removeEventListener('resize', programmer)
                if (frame !== null) window.cancelAnimationFrame(frame)
            }
            ajuster()
            if (typeof window !== 'undefined' && window.ResizeObserver) {
                this._patientStickyObserver = new window.ResizeObserver(ajuster)
                this._patientStickyObserver.observe(entete)
                if (navbar) this._patientStickyObserver.observe(navbar)
                if (scrollport) this._patientStickyObserver.observe(scrollport)
            }
        },
        initialiser_dossier() {
            this.patient_id = this.$route.params.id
            const patient_id = String(this.patient_id)
            this.onglet_patient_actif = '1'
            this.can_see_consultation = false
            this.erreur_tableau_medecin = ''
            this.sequence_contact++
            this.info_personne_a_prevenir = {}
            this.pers_a_prevenir_loading = true
            this.assurance_loading = true
            this.assurance_erreur = false
            this.info_assure_principal = {}
            // Prioriser l'identité et la consultation visible. Sur le serveur local,
            // les requêtes PHP sont servies séquentiellement : les deux lectures
            // secondaires retardaient inutilement l'ouverture du dossier clinique.
            const patient = this.getPatientInfo()
            const consultation = this.getConsultationEnCoursByTypeConsultation()
            Promise.allSettled([patient, consultation]).then(() => {
                if (this._isDestroyed || String(this.$route.params.id) !== patient_id) return
                this.getPersonneAprevenir()
                this.charger_assurance()
            })
        },

        async charger_assurance() {
            const patient_id = this.$route.params.id
            const sequence = ++this.sequence_assurance
            this.info_assure_principal = {}
            this.assurance_loading = true
            this.assurance_erreur = false
            const actuel = () => !this._isDestroyed && sequence === this.sequence_assurance && String(this.$route.params.id) === String(patient_id)
            try {
                const response = await store_patient.getInfoAssurePrincipal(patient_id)
                if (!actuel()) return
                if (!response || typeof response !== 'object' || (Array.isArray(response) && response.length > 0)) throw Error('Réponse assurance invalide')
                if (!Array.isArray(response) && ![0, 1].includes(Number(response.est_assure))) throw Error('Statut assurance invalide')
                this.info_assure_principal = Array.isArray(response) ? { est_assure: 0 } : response
            } catch (error) {
                if (actuel()) this.assurance_erreur = true
            } finally {
                if (actuel()) this.assurance_loading = false
            }
        },

        async getPersonneAprevenir() {
            const patient_id = this.$route.params.id
            const sequence = ++this.sequence_contact
            const actuel = () => !this._isDestroyed && sequence === this.sequence_contact && String(this.$route.params.id) === String(patient_id)
            this.pers_a_prevenir_loading = true
            this.info_personne_a_prevenir = {}
            try {
                const response = await store_patient.getInfoPersonneAPrevenir(patient_id)
                if (actuel()) this.info_personne_a_prevenir = response && !Array.isArray(response) ? response : {}
            } catch (error) {
                if (actuel()) this.info_personne_a_prevenir = {}
            } finally {
                if (actuel()) this.pers_a_prevenir_loading = false
            }
        },

        async getConsultationEnCoursByTypeConsultation() {
            terminerComplement()
            this.erreur_complement = ''
            const patient_id = this.$route.params.id
            const sequence = ++this.sequence_consultation
            const actuel = () => !this._isDestroyed && sequence === this.sequence_consultation && String(this.$route.params.id) === String(patient_id)
            if (this.$route.params.consultation === 'historique') {
                this.can_see_consultation = false
                this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', [])
                this.c_loading = false
                this.changeTab('4')
                return
            }
            const route_query = this.$route.query || {}
            if (Object.prototype.hasOwnProperty.call(route_query, 'sf001')) {
                return this.ouvrir_consultation_tableau_medecin({
                    consultation_id: Number(route_query.sf001), patient_id: Number(patient_id),
                    tarif_consultation_id: Number(route_query.tarif), source_tableau_sage_femme: true
                })
            }
            if (Object.prototype.hasOwnProperty.call(route_query, 'inf001')) {
                return this.ouvrir_consultation_tableau_medecin({
                    consultation_id: Number(route_query.inf001), patient_id: Number(patient_id),
                    tarif_consultation_id: Number(route_query.tarif), source_tableau_infirmier: true
                })
            }
            // Exact intent survives a hard reload even if the Vuex selection was cleared.
            if (Object.prototype.hasOwnProperty.call(route_query, 'med004')) {
                return this.ouvrir_consultation_tableau_medecin({
                    consultation_id: Number(route_query.med004),
                    patient_id: Number(this.$route.params.id),
                    tarif_consultation_id: Number(route_query.tarif)
                })
            }
            if (this.selected_consultation_encours.source_tableau_sage_femme || this.selected_consultation_encours.source_tableau_medecin || this.selected_consultation_encours.source_tableau_infirmier) {
                return this.ouvrir_consultation_tableau_medecin()
            }
            this.c_loading = true
            this.can_see_consultation = false
            this.erreur_tableau_medecin = ''
            this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', [])
            this.selected_consultation_encours.user_id = this.userCredentials.id
            const param = {...this.selected_consultation_encours}

            try {
                if (Number(param.patient_id) !== Number(patient_id)) throw new Error('Patient de la consultation invalide')
                const consultation = await store_consultation.getPatientLatestConsultation(param)
                if (!actuel()) return
                this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', consultation)
                if (this.consultationEnCours.length == 0) {
                    this.can_see_consultation = false
    
                    this.changeTab('4')
                } else {
                    let data = {
                        auth_id: this.userCredentials.id,
                        data_type: 'type_consultation'
                    }
    
                    if (this.$route.params.consultation == "consulter" || this.$route.params.consultation == "traitement-encours") {
                        await this.$store.dispatch('getAccessCheckerToTypePrestation', data)
                        if (!actuel()) return
                        // L'on vérifie si l'utilisateur connecté a l'habileté de consulter un patient
                        // pour le type de consultation en question
                        let type_consultation_id = this.consultationEnCours.tarif_consultation.type_consultation.id
                        if (this.liste_access_checker_type_consultation.includes(type_consultation_id)) {
                            this.can_see_consultation = true

                            if (this.$route.params.consultation === 'consulter') {
                                this.changeTab(this.selected_consultation_encours.view_treatment == 1 ? '10' : '3')
                            }
                        } else {
                            this.can_see_consultation = false
                            this.changeTab('1')
                        }
                    } else if (this.$route.params.consultation == "travailleur") {
                        // si un profil de médécine clinique se connecte ici
                        if (this.user_role == 'ROLE_MEDECIN' || this.user_role == 'ROLE_INFIRMIER') {
                            this.$router.push({ path: '/patients/' + this.$route.params.id + '/consulter' })
                        }
                    }
                }
            } catch (error) {
                if (actuel()) this.erreur_tableau_medecin = this.messageErreurConsultation(error)
            } finally {
                if (actuel()) {
                    this.c_loading = false
                }
            }
        },

        async ouvrir_consultation_tableau_medecin(selection_route) {
            terminerComplement()
            const sequence = ++this.sequence_consultation
            this.c_loading = true
            this.can_see_consultation = false
            this.erreur_tableau_medecin = ''
            this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', [])
            const selected = {...(selection_route || this.selected_consultation_encours)}
            const sageFemme = selected.source_tableau_sage_femme === true
            const infirmier = !sageFemme && selected.source_tableau_infirmier === true
            const patient_id = Number(this.$route.params.id)
            const acteur_id = Number((this.userCredentials || {}).id)
            const roleActuel = () => this.activeRole ? this.activeRole.nom : this.user_role
            const roleInitial = roleActuel()
            const actuel = () => !this._isDestroyed && sequence === this.sequence_consultation &&
                Number(this.$route.params.id) === patient_id && Number((this.userCredentials || {}).id) === acteur_id &&
                (!sageFemme || roleActuel() === roleInitial)
            try {
                const identifiants = [Number(selected.consultation_id), Number(selected.tarif_consultation_id)]
                if (Number(selected.patient_id) !== patient_id || identifiants.some(id => !Number.isInteger(id) || id <= 0)) {
                    throw new Error('Consultation invalide')
                }
                if (sageFemme && roleInitial !== 'ROLE_SAGE_FEMME') throw new Error('Rôle sage-femme requis')
                if (infirmier && this.user_role !== 'ROLE_INFIRMIER') throw new Error('Rôle infirmier requis')
                const credential = await (sageFemme ? sage_femme_api.getTableauMedecinAccess() : infirmier ? infirmier_api.getTableauInfirmierAccess() : store_consultation.getTableauMedecinAccess())
                if (!actuel()) return
                if (!credential.success || !credential.data || !credential.data.access_token) throw new Error('Accès indisponible')
                const suiviInfirmier = infirmier && this.$route.query.suivi === 'traitement'
                const ouvrir = suiviInfirmier ? infirmier_api.ouvrirSuiviSoins
                    : (sageFemme ? sage_femme_api.ouvrirConsultationTableauMedecin : infirmier ? infirmier_api.ouvrirConsultation : store_consultation.ouvrirConsultationTableauMedecin)
                const response = await ouvrir({
                    consultation_id: selected.consultation_id,
                    patient_id,
                    tarif_consultation_id: selected.tarif_consultation_id,
                    access_token: credential.data.access_token
                })
                if (!actuel()) return
                if (!response || Number(response.id) !== Number(selected.consultation_id)) throw new Error('Consultation indisponible')
                if (Number(response.is_end) === 1 && (infirmier || !response.complement || !response.complement.jusqu_au)) {
                    throw new Error('Consultation clôturée')
                }
                if (!infirmier && Number(response.is_end) === 1 && response.complement) {
                    response.timezone = fuseauComplement(response.complement.fuseau)
                    ouvrirComplement({ consultation_id: response.id, patient_id }, credential.data.access_token,
                        () => store_consultation.getTableauMedecinAccess())
                }
                this.$store.commit('SET_PATIENT_LATEST_CONSULTATION', response)
                this.$store.commit('SET_SELECTED_CONSULTATION_ENCOURS', {
                    user_id: this.userCredentials.id,
                    consultation_id: Number(selected.consultation_id),
                    patient_id,
                    tarif_consultation_id: Number(selected.tarif_consultation_id),
                    ...(sageFemme ? { source_tableau_sage_femme: true } : {}),
                    source_tableau_medecin: !infirmier && !sageFemme,
                    source_tableau_infirmier: infirmier
                })
                this.can_see_consultation = true
                const complement = !infirmier && Number(response.is_end) === 1 && response.complement
                this.changeTab(complement ? '4' : infirmier && this.$route.query.suivi === 'traitement' ? '10' : '3')
            } catch (error) {
                if (actuel()) this.erreur_tableau_medecin = this.messageErreurConsultation(error)
            } finally {
                if (actuel()) {
                    this.c_loading = false
                }
            }
        },

        messageErreurConsultation(error) {
            const status = Number(error && error.response && error.response.status)
            const serverMessage = error && error.response && error.response.data && error.response.data.message
            const localMessage = error && error.message
            if (localMessage === 'fuseau non réglé') return localMessage
            // Fuseau absent des Paramètres (503 fuseau_non_regle) : le message du serveur dit quoi régler.
            if (error && error.response && error.response.data && error.response.data.code === 'fuseau_non_regle') return serverMessage
            // Ne jamais déduire une clôture/réattribution d'une simple erreur d'accès.
            if (status === 409 && serverMessage === 'Le bon de consultation a expiré.') {
                return 'Le bon de consultation a expiré. Faites vérifier sa validité à l’accueil ou à la caisse, puis rouvrez la consultation depuis le tableau de bord.'
            }
            if (localMessage === 'Consultation clôturée') {
                return 'Cette consultation est clôturée. Pour relire son compte rendu, ouvrez l’onglet « Historique de consultation ».'
            }
            if (status === 401) return 'Votre autorisation d’accès n’a pas pu être validée. Revenez au tableau de bord et rouvrez la consultation. Si le problème persiste, reconnectez-vous.'
            if (status === 403 || localMessage === 'Rôle sage-femme requis' || localMessage === 'Rôle infirmier requis') return 'L’accès est refusé avec votre profil actif. Revenez au tableau de bord ou demandez à un administrateur de vérifier vos droits.'
            if (status === 404 || localMessage === 'Consultation indisponible') return 'La consultation demandée n’est pas disponible pour votre profil. Le serveur ne précise pas si elle est absente ou inaccessible. Revenez au tableau de bord pour sélectionner une consultation accessible.'
            if (status === 422 || localMessage === 'Consultation invalide' || localMessage === 'Patient de la consultation invalide') return 'Le lien ne permet pas d’identifier correctement la consultation de ce patient. Revenez au tableau de bord et ouvrez-la à nouveau depuis sa ligne.'
            if (status >= 500 || localMessage === 'Accès indisponible') return 'Le service d’ouverture des consultations est temporairement indisponible. Réessayez depuis le tableau de bord ; si cela persiste, contactez le support.'
            if (error && (error.code === 'ECONNABORTED' || error.code === 'ERR_NETWORK' || localMessage === 'Network Error')) return 'Le serveur n’a pas répondu. Vérifiez votre connexion, puis réessayez depuis le tableau de bord.'
            if (serverMessage) return serverMessage
            return 'Le chargement a échoué sans raison précise fournie par le serveur. Revenez au tableau de bord et réessayez. Ce message ne confirme ni une clôture ni une expiration de la consultation.'
        },

        changeTab(tabindex) {
            this.onglet_patient_actif = String(tabindex)
            if (this.onglet_patient_actif === '10') this.toggleTraitementView()
        },

        toggleTraitementView() {
            this.traitement_view_toggler = (this.traitement_view_toggler == 0)?1:0
        },

        /**
         * Ajoute la section Examen biologique
         */
        addAnalyse() {
            this.$refs.cours.addAnalyse()
        },

        /**
         * Ajoute la section CONDITION A TENIR
         */
        addCAT() {
            this.$refs.cours.showCAT()
        },

        /** 
         * Ajoute la section ordonnance
         */
        addOrdonnance() {
            this.$refs.cours.showOrdonnance()
        },

        async getPatientInfo() {
            const patient_id = this.$route.params.id
            const sequence = ++this.sequence_patient
            const actuel = () => !this._isDestroyed && sequence === this.sequence_patient && String(this.$route.params.id) === String(patient_id)
            this.is_loading = true
            this.data_is_available = false
            try {
                const patient = await store_patient.getPatient(patient_id)
                if (!actuel()) return
                if (!patient || Number(patient.id) !== Number(patient_id)) throw Error('Patient indisponible')
                this.$store.commit('SET_PATIENT', patient)
                this.data_is_available = true
            } catch (error) {
                if (actuel()) this.data_is_available = false
            } finally {
                if (actuel()) {
                    this.is_loading = false
                }
            }
        },

        printResultatPatient() {
            this.can_print = true
            this.results = this.resulat_patient_to_print
            
            setTimeout(() => {
                window.print()

                this.can_print = false
                this.$store.commit("SET_CAN_PRINT_RESULT", false)
                this.$store.commit("SET_RESULAT_PATIENT_TO_PRINT", {})
            }, 1500);
        },
    }
}
